import { useId } from 'react';

/**
 * Biodimension Cryopreservation Tool logo mark.
 * A six-arm ice crystal on a teal gradient tile — matches the favicon
 * (public/favicon.svg). Keep the two in sync if the artwork changes.
 */
export default function Logo({ size = 32, title = 'Cryopreservation Tool logo' }: { size?: number; title?: string }) {
  const gradId = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#149aab" />
          <stop offset="1" stopColor="#0a5f6d" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill={`url(#${gradId})`} />
      {/* soft top sheen */}
      <path d="M15 0h34a15 15 0 0 1 15 15v6c-21 8-43 8-64 0v-6A15 15 0 0 1 15 0Z" fill="#ffffff" opacity="0.1" />
      <g stroke="#ffffff" strokeWidth="3" strokeLinecap="round" fill="none">
        <g>
          <path d="M32 27V12M32 16l-4.4 4.4M32 16l4.4 4.4" />
          <path d="M32 27V12M32 16l-4.4 4.4M32 16l4.4 4.4" transform="rotate(60 32 32)" />
          <path d="M32 27V12M32 16l-4.4 4.4M32 16l4.4 4.4" transform="rotate(120 32 32)" />
          <path d="M32 27V12M32 16l-4.4 4.4M32 16l4.4 4.4" transform="rotate(180 32 32)" />
          <path d="M32 27V12M32 16l-4.4 4.4M32 16l4.4 4.4" transform="rotate(240 32 32)" />
          <path d="M32 27V12M32 16l-4.4 4.4M32 16l4.4 4.4" transform="rotate(300 32 32)" />
        </g>
      </g>
      <circle cx="32" cy="32" r="3.4" fill="#ffffff" />
    </svg>
  );
}
